import * as React from 'react';

const YesNoDialog = ({ show, model, onClosePopup }) => {

	const onClose = React.useCallback(() => {
		onClosePopup?.();
	}, [onClosePopup]);

	const handleYes = React.useCallback((e) => {
		e?.stopPropagation?.();
		onClosePopup?.();
		model?.onYes?.();
	}, [model, onClosePopup]);

	const handleNo = React.useCallback((e) => {
		e.stopPropagation();
		onClosePopup?.();
		model?.onNo?.();
	}, [model, onClosePopup]);

	return (
		(show &&
			<div
				className="dialogBox"
				onClick={onClose}
			>
				<div className="dialogBoxWindow" style={{
					width: '300px',
				}}>
					<header>
						<a className="close cursor">X</a>
					</header>
					<main>

						<div className="text-center" style={{
							padding: '10px 5px 5px 5px',
						}}>
							<p>{model.message || 'Having fun?'}</p>
						</div>

					</main>
					<footer>
						<div className="text-center" style={{
							padding: '10px 5px 5px 5px',
						}}>
							<a className="simpleButtonOutLine width-100px" onClick={handleYes}>
								Yes
							</a>
							<a className="simpleButtonOutLine width-100px" onClick={handleNo}>
								No
							</a>
						</div>
					</footer>
				</div>
			</div>
		)
	);
};

export default YesNoDialog;
